// GENERATED by tools/gen_display_names.py from theme 'revival' (reskin-map/REVIVAL-Names-VALIDATED.xlsx).
// DO NOT EDIT BY HAND - re-run the generator. The workbook is the one owner of names.
//
// WHY A RENAME LAYER AT ALL: a faction/quadrant/race value in the served data is an
// IDENTIFIER the engine deserialises, so it cannot be renamed in data without breaking the
// enum. The rename happens where the player READS it, never where the engine COMPUTES.
//
// ORDERED LONGEST FIRST, so a compound name matches before a bare word inside it.
export const DISPLAY_NAMES: ReadonlyArray<readonly [string, string]> = [
  ["Kallisto, Forest Protector", "Old Grizzly, Forest Protector"],
  ["KALLISTO, FOREST PROTECTOR", "OLD GRIZZLY, FOREST PROTECTOR"],
  ["Termeris, Amazon Renegade", "Tess Mercer, Frontier Renegade"],
  ["Kaustikia, Dragon of acid", "The Caustic Bayou Drake"],
  ["Jas, Scholar of Asclepius", "Jasper, Student of the Greenward"],
  ["Fountain of Eternal Youth", "Spring of New Beginnings"],
  ["TERMERIS, AMAZON RENEGADE", "TESS MERCER, FRONTIER RENEGADE"],
  ["KAUSTIKIA, DRAGON OF ACID", "THE CAUSTIC BAYOU DRAKE"],
  ["JAS, SCHOLAR OF ASCLEPIUS", "JASPER, STUDENT OF THE GREENWARD"],
  ["FOUNTAIN OF ETERNAL YOUTH", "SPRING OF NEW BEGINNINGS"],
  ["The_Order_of_Sagittarius", "The Ridgeline Rangers"],
  ["The Order of Sagittarius", "The Ridgeline Rangers"],
  ["Silver Scalemail Corslet", "Silver Scale Vest"],
  ["Eriboa the Quartermaster", "Erin Boone, Quartermaster"],
  ["Chiron, Tutor of Legends", "Longtrail, Tutor of Legends"],
  ["THE_ORDER_OF_SAGITTARIUS", "THE RIDGELINE RANGERS"],
  ["THE ORDER OF SAGITTARIUS", "THE RIDGELINE RANGERS"],
  ["SILVER SCALEMAIL CORSLET", "SILVER SCALE VEST"],
  ["ERIBOA THE QUARTERMASTER", "ERIN BOONE, QUARTERMASTER"],
  ["CHIRON, TUTOR OF LEGENDS", "LONGTRAIL, TUTOR OF LEGENDS"],
  ["Tomyios the Unsurpassed", "Mudgrin the Unsurpassed"],
  ["Storm of Blood and Fire", "Bloodfire Tempest"],
  ["TOMYIOS THE UNSURPASSED", "MUDGRIN THE UNSURPASSED"],
  ["STORM OF BLOOD AND FIRE", "BLOODFIRE TEMPEST"],
  ["Jas, Junior Lorekeeper", "Jasper, Junior Chronicler"],
  ["Ent of the Deep Forest", "Old-Growth Walker"],
  ["JAS, JUNIOR LOREKEEPER", "JASPER, JUNIOR CHRONICLER"],
  ["ENT OF THE DEEP FOREST", "OLD-GROWTH WALKER"],
  ["Glaukos the Duellist", "Gideon Glass, the Duellist"],
  ["Kobaloi Fire Thrower", "Sinkhole Gremlin Fire-Slinger"],
  ["GLAUKOS THE DUELLIST", "GIDEON GLASS, THE DUELLIST"],
  ["KOBALOI FIRE THROWER", "SINKHOLE GREMLIN FIRE-SLINGER"],
  ["Mountains of Boreas", "Domain of Negafook"],
  ["Underworld of Hades", "The Spirit Veil"],
  ["Iskandrian_Hegemony", "The Sunfall Dominion"],
  ["Iskandrian Hegemony", "The Sunfall Dominion"],
  ["Daemons_of_the_Dark", "The Gloamkin"],
  ["Daemons of the Dark", "The Gloamkin"],
  ["Company_of_Hoplites", "The Free Company"],
  ["Company of Hoplites", "The Free Company"],
  ["Pouch of Gold Obols", "Pouch of Gold Eagles"],
  ["Drakonewt Hatchling", "Bayou Drake Hatchling"],
  ["Kobaloi infestation", "Sinkhole Gremlin Infestation"],
  ["MOUNTAINS OF BOREAS", "DOMAIN OF NEGAFOOK"],
  ["UNDERWORLD OF HADES", "THE SPIRIT VEIL"],
  ["ISKANDRIAN_HEGEMONY", "THE SUNFALL DOMINION"],
  ["ISKANDRIAN HEGEMONY", "THE SUNFALL DOMINION"],
  ["DAEMONS_OF_THE_DARK", "THE GLOAMKIN"],
  ["DAEMONS OF THE DARK", "THE GLOAMKIN"],
  ["COMPANY_OF_HOPLITES", "THE FREE COMPANY"],
  ["COMPANY OF HOPLITES", "THE FREE COMPANY"],
  ["POUCH OF GOLD OBOLS", "POUCH OF GOLD EAGLES"],
  ["DRAKONEWT HATCHLING", "BAYOU DRAKE HATCHLING"],
  ["KOBALOI INFESTATION", "SINKHOLE GREMLIN INFESTATION"],
  ["Gardens of Arcadia", "The Verdant Hollow"],
  ["Lost_Shade / Shade", "Wraith"],
  ["Lost Shade / Shade", "Wraith"],
  ["Amazonian Aspirant", "Frontier Aspirant"],
  ["Avatar of Thanatos", "Avatar of the Last Crossing"],
  ["Call of the Satyrs", "Call of the Pinehorns"],
  ["Jas, The Herbalist", "Jasper, the Herbalist"],
  ["Rooted Restoration", "Deep-Root Renewal"],
  ["GARDENS OF ARCADIA", "THE VERDANT HOLLOW"],
  ["LOST_SHADE / SHADE", "WRAITH"],
  ["LOST SHADE / SHADE", "WRAITH"],
  ["AMAZONIAN ASPIRANT", "FRONTIER ASPIRANT"],
  ["AVATAR OF THANATOS", "AVATAR OF THE LAST CROSSING"],
  ["CALL OF THE SATYRS", "CALL OF THE PINEHORNS"],
  ["JAS, THE HERBALIST", "JASPER, THE HERBALIST"],
  ["ROOTED RESTORATION", "DEEP-ROOT RENEWAL"],
  ["Priests_of_Khemet", "The Ashen Covenant"],
  ["Priests of Khemet", "The Ashen Covenant"],
  ["The Summer Palace", "The Sunlit Lodge"],
  ["The Eye of Typhon", "The Eye of the Tempest"],
  ["Forgotten Spartoi", "Forgotten Boneguard"],
  ["Aella, War Mentor", "Ada Bell, War Mentor"],
  ["Kobaloi Recruiter", "Sinkhole Gremlin Recruiter"],
  ["Corrupted Centaur", "Blighted Plainsborn"],
  ["PRIESTS_OF_KHEMET", "THE ASHEN COVENANT"],
  ["PRIESTS OF KHEMET", "THE ASHEN COVENANT"],
  ["THE SUMMER PALACE", "THE SUNLIT LODGE"],
  ["THE EYE OF TYPHON", "THE EYE OF THE TEMPEST"],
  ["FORGOTTEN SPARTOI", "FORGOTTEN BONEGUARD"],
  ["AELLA, WAR MENTOR", "ADA BELL, WAR MENTOR"],
  ["KOBALOI RECRUITER", "SINKHOLE GREMLIN RECRUITER"],
  ["CORRUPTED CENTAUR", "BLIGHTED PLAINSBORN"],
  ["The_Horned_Lodge", "The Antler Lodge"],
  ["The Horned Lodge", "The Antler Lodge"],
  ["Cyclops Defender", "One-Eyed Defender"],
  ["Jas the Unliving", "Jasper the Restless"],
  ["Kobaloi Pillager", "Sinkhole Gremlin Pillager"],
  ["Cloak of Meteors", "Cloak of Falling Stars"],
  ["Centaur Vanguard", "Plainsborn Vanguard"],
  ["Terrifying Growl", "The Grizzly's Warning"],
  ["House of Records", "Hall of Tall Tales"],
  ["Pactbound Undead", "Oathbound Restless"],
  ["THE_HORNED_LODGE", "THE ANTLER LODGE"],
  ["THE HORNED LODGE", "THE ANTLER LODGE"],
  ["CYCLOPS DEFENDER", "ONE-EYED DEFENDER"],
  ["JAS THE UNLIVING", "JASPER THE RESTLESS"],
  ["KOBALOI PILLAGER", "SINKHOLE GREMLIN PILLAGER"],
  ["CLOAK OF METEORS", "CLOAK OF FALLING STARS"],
  ["CENTAUR VANGUARD", "PLAINSBORN VANGUARD"],
  ["TERRIFYING GROWL", "THE GRIZZLY'S WARNING"],
  ["HOUSE OF RECORDS", "HALL OF TALL TALES"],
  ["PACTBOUND UNDEAD", "OATHBOUND RESTLESS"],
  ["Desert of Notus", "The Scorched Expanse"],
  ["Mormo the Lamia", "Mercy Morrow, Swamp Serpent"],
  ["Myrmidon Armour", "Mesa Legion Armour"],
  ["Dervish Warrior", "Dustwhirl Warrior"],
  ["Kobaloi Warrior", "Sinkhole Gremlin Warrior"],
  ["Child of Nature", "Child of the Wild"],
  ["Caladonian Boar", "Cumberland Razorback"],
  ["Myrmidon Mystic", "Mesa Legion Mystic"],
  ["DESERT OF NOTUS", "THE SCORCHED EXPANSE"],
  ["MORMO THE LAMIA", "MERCY MORROW, SWAMP SERPENT"],
  ["MYRMIDON ARMOUR", "MESA LEGION ARMOUR"],
  ["DERVISH WARRIOR", "DUSTWHIRL WARRIOR"],
  ["KOBALOI WARRIOR", "SINKHOLE GREMLIN WARRIOR"],
  ["CHILD OF NATURE", "CHILD OF THE WILD"],
  ["CALADONIAN BOAR", "CUMBERLAND RAZORBACK"],
  ["MYRMIDON MYSTIC", "MESA LEGION MYSTIC"],
  ["Frank_Frazetta", "The Long Hunt"],
  ["Frank Frazetta", "The Long Hunt"],
  ["Sunfire Strike", "High-Noon Blaze"],
  ["Verdant Growth", "Wildwood Bloom"],
  ["Vile Swamp Gas", "Bayou Miasma"],
  ["Kobaloi Shaman", "Sinkhole Gremlin Hexer"],
  ["Centaur Archer", "Plainsborn Archer"],
  ["Secluded Glade", "Hidden Hollow"],
  ["FRANK_FRAZETTA", "THE LONG HUNT"],
  ["FRANK FRAZETTA", "THE LONG HUNT"],
  ["SUNFIRE STRIKE", "HIGH-NOON BLAZE"],
  ["VERDANT GROWTH", "WILDWOOD BLOOM"],
  ["VILE SWAMP GAS", "BAYOU MIASMA"],
  ["KOBALOI SHAMAN", "SINKHOLE GREMLIN HEXER"],
  ["CENTAUR ARCHER", "PLAINSBORN ARCHER"],
  ["SECLUDED GLADE", "HIDDEN HOLLOW"],
  ["Mirror Shield", "Polished Tin Shield"],
  ["Mangrave Tree", "Gallows Mangrove"],
  ["MIRROR SHIELD", "POLISHED TIN SHIELD"],
  ["MANGRAVE TREE", "GALLOWS MANGROVE"],
  ["The_Wild_Way", "The Bramble-Walkers"],
  ["The Wild Way", "The Bramble-Walkers"],
  ["Queen Xanthe", "Rowan, Queen of the Range"],
  ["Boar Catcher", "Razorback Catcher"],
  ["THE_WILD_WAY", "THE BRAMBLE-WALKERS"],
  ["THE WILD WAY", "THE BRAMBLE-WALKERS"],
  ["QUEEN XANTHE", "ROWAN, QUEEN OF THE RANGE"],
  ["BOAR CATCHER", "RAZORBACK CATCHER"],
  ["The_Amazons", "The Longhunt Sisterhood"],
  ["The Amazons", "The Longhunt Sisterhood"],
  ["Nightshades", "Graveyard Nightshade"],
  ["THE_AMAZONS", "THE LONGHUNT SISTERHOOD"],
  ["THE AMAZONS", "THE LONGHUNT SISTERHOOD"],
  ["NIGHTSHADES", "GRAVEYARD NIGHTSHADE"],
  ["nightshades", "graveyard nightshade"],
  ["The_Shades", "The Pale Wake"],
  ["The Shades", "The Pale Wake"],
  ["Blacksmith", "Master Smith"],
  ["Lava Golem", "Cinderstone Giant"],
  ["Spiderling", "Widowling"],
  ["THE_SHADES", "THE PALE WAKE"],
  ["THE SHADES", "THE PALE WAKE"],
  ["BLACKSMITH", "MASTER SMITH"],
  ["LAVA GOLEM", "CINDERSTONE GIANT"],
  ["SPIDERLING", "WIDOWLING"],
  ["blacksmith", "master smith"],
  ["spiderling", "widowling"],
  ["Elemental", "Spirit"],
  ["Automaton", "Boilerplate"],
  ["Quadrants", "Realms"],
  ["COLOSSEUM", "THE PROVING GROUND"],
  ["Colosseum", "The Proving Ground"],
  ["Venomtail", "Redrock Stinger"],
  ["Wild Boar", "Razorback Boar"],
  ["ELEMENTAL", "SPIRIT"],
  ["AUTOMATON", "BOILERPLATE"],
  ["QUADRANTS", "REALMS"],
  ["VENOMTAIL", "REDROCK STINGER"],
  ["WILD BOAR", "RAZORBACK BOAR"],
  ["elemental", "spirit"],
  ["automaton", "boilerplate"],
  ["quadrants", "realms"],
  ["colosseum", "the proving ground"],
  ["venomtail", "redrock stinger"],
  ["Building", "Holdfast"],
  ["Artefact", "Relic"],
  ["Quadrant", "Realm"],
  ["Myrmidon", "Warband"],
  ["Wardrums", "Frontier War Drums"],
  ["BUILDING", "HOLDFAST"],
  ["ARTEFACT", "RELIC"],
  ["QUADRANT", "REALM"],
  ["MYRMIDON", "WARBAND"],
  ["WARDRUMS", "FRONTIER WAR DRUMS"],
  ["building", "holdfast"],
  ["artefact", "relic"],
  ["quadrant", "realm"],
  ["myrmidon", "warband"],
  ["wardrums", "frontier war drums"],
  ["Termeris", "Tess Mercer"],
  ["Kallisto", "Old Grizzly"],
  ["TERMERIS", "TESS MERCER"],
  ["KALLISTO", "OLD GRIZZLY"],
  ["Arcadia", "The Verdant Hollow"],
  ["Neutral", "Drifters of the Open Road"],
  ["Centaur", "Ridebound"],
  ["Cyclops", "Hillgiant"],
  ["Spartoi", "Bonewalkers"],
  ["Kobaloi", "Tricksters"],
  ["ARCADIA", "THE VERDANT HOLLOW"],
  ["NEUTRAL", "DRIFTERS OF THE OPEN ROAD"],
  ["CENTAUR", "RIDEBOUND"],
  ["CYCLOPS", "HILLGIANT"],
  ["SPARTOI", "BONEWALKERS"],
  ["KOBALOI", "TRICKSTERS"],
  ["arcadia", "the verdant hollow"],
  ["neutral", "drifters of the open road"],
  ["centaur", "ridebound"],
  ["cyclops", "hillgiant"],
  ["spartoi", "bonewalkers"],
  ["kobaloi", "tricksters"],
  ["Boreas", "Domain of Negafook"],
  ["Daemon", "Haint"],
  ["Dragon", "Thunderwyrm"],
  ["Gorgon", "Stonegaze cryptid"],
  ["Spider", "Weaver"],
  ["Arctus", "Grizzly"],
  ["Sphinx", "The Canyon Riddlecat"],
  ["BOREAS", "DOMAIN OF NEGAFOOK"],
  ["DAEMON", "HAINT"],
  ["DRAGON", "THUNDERWYRM"],
  ["GORGON", "STONEGAZE CRYPTID"],
  ["SPIDER", "WEAVER"],
  ["ARCTUS", "GRIZZLY"],
  ["SPHINX", "THE CANYON RIDDLECAT"],
  ["boreas", "domain of negafook"],
  ["daemon", "haint"],
  ["dragon", "thunderwyrm"],
  ["gorgon", "stonegaze cryptid"],
  ["spider", "weaver"],
  ["arctus", "grizzly"],
  ["sphinx", "the canyon riddlecat"],
  ["Chiron", "Longtrail"],
  ["CHIRON", "LONGTRAIL"],
  ["Hades", "The Spirit Veil"],
  ["Notus", "The Scorched Expanse"],
  ["Human", "Frontierfolk"],
  ["Beast", "Wildbeast"],
  ["Harpy", "Screecher"],
  ["Lamia", "Serpentkin"],
  ["Strix", "Nightbird"],
  ["Druid", "Wildwarden"],
  ["Dryad", "Thicket"],
  ["HADES", "THE SPIRIT VEIL"],
  ["NOTUS", "THE SCORCHED EXPANSE"],
  ["HUMAN", "FRONTIERFOLK"],
  ["BEAST", "WILDBEAST"],
  ["HARPY", "SCREECHER"],
  ["LAMIA", "SERPENTKIN"],
  ["STRIX", "NIGHTBIRD"],
  ["DRUID", "WILDWARDEN"],
  ["DRYAD", "THICKET"],
  ["hades", "the spirit veil"],
  ["notus", "the scorched expanse"],
  ["human", "frontierfolk"],
  ["beast", "wildbeast"],
  ["harpy", "screecher"],
  ["lamia", "serpentkin"],
  ["strix", "nightbird"],
  ["druid", "wildwarden"],
  ["dryad", "thicket"],
  ["Aella", "Ada Bell"],
  ["AELLA", "ADA BELL"],
  ["Wolf", "Direwolf"],
  ["WOLF", "DIREWOLF"],
  ["wolf", "direwolf"],
  ["Fae", "Sprite"],
  ["FAE", "SPRITE"],
  ["fae", "sprite"],
  ["Jas", "Jasper"],
  ["JAS", "JASPER"],
];

/** Rename one identifier for display. Returns a readable fallback when nothing owns it. */
export function displayName(raw: string | undefined | null): string {
  const s = String(raw ?? "");
  if (!s) return "";
  for (const [from, to] of DISPLAY_NAMES) if (s === from) return to;
  /* An unowned identifier is still shown to a player, so it must at least read as words. */
  return s.replace(/_/g, " ");
}

/**
 * Rewrite the previous studio's names INSIDE a sentence.
 *
 * WHY THIS EXISTS, AND WHY displayName COULD NEVER HAVE DONE IT. displayName matches the WHOLE
 * string (s === from), which is right for an IDENTIFIER - a faction key, a race, a quadrant. It
 * cannot touch a name appearing mid-sentence, and card RULES TEXT is full of them. Measured on
 * the served pool 2026-08-20: 17 player-readable strings still said Kallisto, Chiron, Myrmidon,
 * Kobaloi, centaur or Arctus - including "While Kallisto is in play other Beast you control have
 * +0/+2" and "Summon Arctus Bears".
 *
 * Unity already had this: RevivalTextSkin's sweeper rewrites UI text token by token. The web
 * client, which is the product now, had no equivalent, so every one of those rendered raw.
 *
 * TOKEN-BOUNDARY MATCHING, NEVER A BARE replace(): a substring pass turns "Ares" inside
 * "Aresmith" into nonsense. This mirrors _tok_replace in the generator exactly - a match counts
 * only when neither neighbour is alphanumeric.
 *
 * LONGEST FIRST, so a compound name is rewritten before a bare word inside it. The generator
 * emits DISPLAY_NAMES in that order and PROVES the result idempotent, so a second sweep over the
 * output changes nothing.
 */
export function skinText(raw: string | undefined | null): string {
  let t = String(raw ?? "");
  if (!t) return "";
  for (const [from, to] of DISPLAY_NAMES) {
    if (from.length < 4 || !t.includes(from)) continue;
    let out = "";
    let i = 0;
    for (;;) {
      const at = t.indexOf(from, i);
      if (at < 0) { out += t.slice(i); break; }
      const end = at + from.length;
      const leftOk = at === 0 || !/[A-Za-z0-9_]/.test(t.charAt(at - 1));
      const rightOk = end >= t.length || !/[A-Za-z0-9_]/.test(t.charAt(end));
      out += t.slice(i, at) + (leftOk && rightOk ? to : from);
      i = end;
    }
    t = out;
  }
  return t;
}
